import {
  ADD_NEW_CAMPAIGNS_FAILED,
  ADD_NEW_CAMPAIGNS_REQUEST,
  ADD_NEW_CAMPAIGNS_SUCCESS,
  CLEAR_ADD_NEW_CAMPAIGNS_RESPONSE,
  DELETE_TAG_CAMPAIGN_FAILED,
  DELETE_TAG_CAMPAIGN_REQUEST,
  DELETE_TAG_CAMPAIGN_SUCCESS,
  GET_CAMPAIGNS_LIST_SUCCESS,
  GET_EDIT_TAG_DATA_FAILED,
  GET_EDIT_TAG_DATA_REQUEST,
  GET_EDIT_TAG_DATA_SUCCESS,
  GET_TAG_GENERATOR_SUCCESS,
  UPDATE_EDIT_TAG_DATA_FAILED,
  UPDATE_EDIT_TAG_DATA_REQUEST,
  UPDATE_EDIT_TAG_DATA_SUCCESS,
} from "../Actions/TagGeneratorAction";

const InitialState = {
  campaignList: [],
  tagData: "",
  loading: false,
  redirect: false,
  success: false,
  edit_data: [],
};

export const TagGeneratorReducer = (state = InitialState, action: any) => {
  switch (action.type) {
    case GET_CAMPAIGNS_LIST_SUCCESS:
      return {
        ...state,
        campaignList: action.payload,
        tagData: "",
      };

    case GET_TAG_GENERATOR_SUCCESS:
      return {
        ...state,
        tagData: action.payload,
      };

    case ADD_NEW_CAMPAIGNS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case ADD_NEW_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        loading: false,
        redirect: true,
      };

    case ADD_NEW_CAMPAIGNS_FAILED:
      return {
        ...state,
        loading: false,
        redirect: true,
      };

    case GET_EDIT_TAG_DATA_REQUEST:
      return {
        ...state,
        success: false,
      };

    case GET_EDIT_TAG_DATA_SUCCESS:
      return {
        ...state,
        edit_data: action.payload,
        success: true,
      };

    case GET_EDIT_TAG_DATA_FAILED:
      return {
        ...state,
        edit_data: action.payload,
        success: false,
      };

    case UPDATE_EDIT_TAG_DATA_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_EDIT_TAG_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        redirect: true,
      };

    case UPDATE_EDIT_TAG_DATA_FAILED:
      return {
        ...state,
        loading: false,
        redirect: false,
      };

    case CLEAR_ADD_NEW_CAMPAIGNS_RESPONSE:
      return {
        ...state,
        loading: false,
        redirect: false,
        success: false,
      };
    case DELETE_TAG_CAMPAIGN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_TAG_CAMPAIGN_SUCCESS:
      return {
        ...state,
        loading: false,

      };
    case DELETE_TAG_CAMPAIGN_FAILED:
      return {
        ...state,
        loading: false,

      };

    default:
      return state;
  }
};
